import React from "react";
import { normalizeProps } from "./utils/normalizeProps";

const DasaIcon = (props) => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...normalizeProps(props)}
    >
      <path
        d="M18.6458 6.00416C17.15 6.00416 15.875 6.28716 14.8167 6.85731C13.7625 7.42747 12.9625 8.23484 12.425 9.28359C11.8875 10.3323 11.6167 11.5684 11.6167 13C11.6167 13.0042 11.6167 13.0125 11.6167 13.0166C11.6125 14.5398 11.2417 15.7051 10.4958 16.5083C9.75 17.3157 8.6875 17.7152 7.30833 17.7152H4.65V8.28478H7.30833C8.6875 8.28478 9.75 8.68847 10.4958 9.49168C10.7958 9.81629 11.0375 10.1992 11.2167 10.6445C11.4042 9.57075 11.7208 8.59691 12.175 7.71046C12.1958 7.66885 12.2167 7.63139 12.2375 7.58977C11.9167 7.31094 11.5625 7.0654 11.175 6.85315C10.1208 6.283 8.84167 6 7.34583 6H2V19.9958H7.35417C8.85 19.9958 10.125 19.7128 11.1833 19.1427C12.2375 18.5725 13.0375 17.7652 13.575 16.7164C14.1125 15.6718 14.3792 14.44 14.3833 13.0166C14.3833 13.0125 14.3833 13.0042 14.3833 13C14.3833 11.4685 14.7583 10.299 15.5042 9.49168C16.25 8.6843 17.3125 8.28478 18.6917 8.28478H21.35V17.7194H18.6917C17.3125 17.7194 16.25 17.3157 15.5042 16.5125C15.2042 16.1879 14.9625 15.8008 14.7792 15.3597C14.5958 16.4459 14.2708 17.4364 13.8167 18.327C13.8 18.3603 13.7833 18.3894 13.7667 18.4227C14.0833 18.6974 14.4375 18.9388 14.825 19.1468C15.8792 19.717 17.1583 20 18.6542 20H24V6.00416H18.6458Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DasaIcon;
